// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3lEi8","header":"MessagesList_header__2gruD","chat":"MessagesList_chat__zujmN"};